/**
 * removeToken.js
 * Written by: Alex Kasemir
 */
import cookie from 'react-cookies';
import { removeStorage } from '@minerva-analytics/pantheon';
import { hosts } from 'utils';

export const REMOVE_TOKEN_START = `REMOVE_TOKEN_START`;
export const REMOVE_TOKEN_SUCCESS = `REMOVE_TOKEN_SUCCESS`;
export const REMOVE_TOKEN_FAILURE = `REMOVE_TOKEN_FAILURE`;

export const removeTokenStart = () => ({
  type: REMOVE_TOKEN_START,
});

export const removeTokenSuccess = () => ({
  type: REMOVE_TOKEN_SUCCESS,
});

export const removeTokenFailure = (error) => ({
  type: REMOVE_TOKEN_FAILURE,
  error,
});

/**
 * Description of the removeToken action
 */
export const removeToken = () => {
  return (dispatch) => {
    dispatch(removeTokenStart());
    if (__CLIENT__) {
      cookie.remove(`jwtToken`, {
        path: `/`,
        domain: hosts.cookieDomain,
      });
      removeStorage({
        key: `jwtToken`,
      });
    }
    dispatch(removeTokenSuccess());
  };
};
